// components/PrivateRoute.tsx
import { LoadState } from '@diditusa/shared/types/commonTypes';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingIndicator from './LoadingIndicator/loadingIndicator';

const PrivateRoute: React.FC = () => {
  const { isAuthenticated, loadState } = useAuth();

  if (loadState === LoadState.LOADING || loadState === LoadState.INIT)
    return <LoadingIndicator isVisible={true} />;
  return isAuthenticated ? <Outlet /> : <Navigate to='/' replace />;
};

export default PrivateRoute;
